import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Sparkles } from "lucide-react";

/**
 * Compact inline pill that queries /field-fills/for-contact/{id} and renders
 *   "Filled from conversation: City = Vashi, Requirement = ACP shopfront"
 * with the evidence phrase surfaced on hover.
 *
 * Renders nothing (returns null) if the contact has zero fills.
 */
export default function FieldFillPill({ ghlContactId, testid }) {
  const [fills, setFills] = useState(null);

  useEffect(() => {
    let active = true;
    if (!ghlContactId) return;
    api
      .get(`/field-fills/for-contact/${ghlContactId}`)
      .then((r) => {
        if (active) setFills(r.data?.fills || []);
      })
      .catch(() => {
        if (active) setFills([]);
      });
    return () => {
      active = false;
    };
  }, [ghlContactId]);

  if (!fills || fills.length === 0) return null;

  const written = fills.filter((f) => f.status === "written");
  const pending = fills.filter((f) => f.status === "pending_review");
  if (written.length === 0 && pending.length === 0) return null;

  return (
    <div className="mt-2 text-[11px] text-zinc-500 flex items-start gap-1.5" data-testid={testid}>
      <Sparkles className="w-3 h-3 text-emerald-400 shrink-0 mt-0.5" />
      <div className="flex flex-wrap gap-x-2 gap-y-1">
        <span className="text-zinc-500">Filled from conversation:</span>
        {written.map((f) => (
          <span
            key={f.id}
            title={f.evidence ? `evidence: "${f.evidence}"` : ""}
            className="text-emerald-300"
          >
            {f.field} = <span className="text-emerald-200">{f.value}</span>
          </span>
        ))}
        {pending.map((f) => (
          <span
            key={f.id}
            title={f.evidence ? `evidence: "${f.evidence}"` : ""}
            className="text-amber-300"
          >
            {f.field} = <span className="text-amber-200">{f.value}</span>
            <span className="text-[9px] uppercase tracking-[0.16em] text-amber-400/70 ml-1">
              pending
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
